import React from 'react';

export default function HousingAllowanceOJTModalContent() {
  return (
    <>
      <div>
        <p>
          Under the GI Bill you’re eligible to receive a monthly housing
          allowance. We calculate this monthly housing allowance based on where
          you take training.
        </p>
        <a href="https://www.benefits.va.gov/gibill/resources/benefits_resources/rate_tables.asp?_ga=2.144591223.39405460.1542131207-1582256389.1508352376">
          View the current housing allowance payment rates
        </a>
        <p>
          For on-the-job training and apprenticeships, housing allowance
          decreases every 6 months as employer pay increases.
        </p>
        <a href="https://www.va.gov/education/about-gi-bill-benefits/how-to-use-benefits/on-the-job-training-apprenticeships/">
          Learn more about how the housing rate decreases over time.
        </a>
      </div>
    </>
  );
}
